import { z } from 'zod';

export const FeatureFlagName = z.enum([
  'leadershipFlag',
  'canUseDimensions',
  'dataQueuingUserAnalysis',
  'canUseMergeDataSets',
  'showStatusForCustomVizLoading',
  'showStaticVarSimilarQualities',
  'dangerouslyExposeNlpGraph',
  'canUseRdbmsS2DatabasesWrite',
  'canUseRdbmsDatabaseRead',
  'showOldResults',
  'canUseRdbmsTransformWrite',
  'canUseRdbmsTransformRead',
]);

export type FeatureFlagName = z.infer<typeof FeatureFlagName>;

export const FeatureFlagNames = Object.values(FeatureFlagName.Values);

// This is not a record type anymore because if we do that, then removing values from the above enum causes parsing errors.
// A little more verbose this way, but it works.
export const FeatureFlags = z.object({
  leadershipFlag: z.boolean().optional(),
  canUseDimensions: z.boolean().optional(),
  dataQueuingUserAnalysis: z.boolean().optional(),
  canUseMergeDataSets: z.boolean().optional(),
  showStatusForCustomVizLoading: z.boolean().optional(),
  showStaticVarSimilarQualities: z.boolean().optional(),
  dangerouslyExposeNlpGraph: z.boolean().optional(),
  canUseRdbmsS2DatabasesWrite: z.boolean().optional(),
  canUseRdbmsDatabaseRead: z.boolean().optional(),
  showOldResults: z.boolean().optional(),
  canUseRdbmsTransformWrite: z.boolean().optional(),
  canUseRdbmsTransformRead: z.boolean().optional(),
});

export type FeatureFlags = z.infer<typeof FeatureFlags>;
